import {PageTitle} from "../PageTitle/PageTitle";
import React, { useState } from "react";
import {WeezBeeCourse} from "../WeezBeeCourse/WeezBeeCourse";
import "./WeezBeeCourseViewer.scss";
import { useParams } from "react-router-dom";
import {Confetti} from "../Smart/Confetti/Confetti";
import { CourseEditorProvider, COURSE_MODES } from "../../contexts/CourseEditorContext";

export const WeezBeeCourseViewer = () => {
    const { signDocId } = useParams();
    const [showConfetti, setShowConfetti] = useState(false);

    // Handle course completion
    const handleCourseCompleted = () => {
        console.log('Course completed in viewer!');
        setShowConfetti(true);

        // Hide confetti after 5 seconds
        setTimeout(() => {
            setShowConfetti(false);
        }, 5000);
    };

    return (
        <div className="WeezBeeCourseViewer MenuPage">
            <Confetti
                showConfetti={showConfetti}
                stopSoundAfter={5000}
                stopConfettiAfter={5000}
            />
            <PageTitle
                size="minimized"
            />
            <div className="menuInnerPage">
                <CourseEditorProvider
                    signDocId={signDocId}
                    initialMode={COURSE_MODES.USER_VIEW}
                >
                    <WeezBeeCourse
                        onCourseCompleted={handleCourseCompleted}
                        signDocId={signDocId}
                    />
                </CourseEditorProvider>
            </div>
        </div>
    );
}
